'use client';
import { jsx } from 'react/jsx-runtime';
import { useState, useMemo } from 'react';
import { SwanCollectionContext } from './collection.context.js';

function CollectionContextProvider(i) {
    let { children: l, items: n } = i, [c, d] = useState(i.disabledKeys), [m, s] = useState(i.disabledKeys);
    c !== m && (d(c), s(c));
    let [a, x] = useState(), f = useMemo(()=>({
            items: n,
            childItems: a,
            setChildItems: x,
            disabledKeys: c,
            setDisabledKeys: d
        }), [
        n,
        a,
        x,
        c,
        d
    ]);
    return jsx(SwanCollectionContext.Provider, {
        value: f,
        children: l
    });
}

export { CollectionContextProvider };
